import { render, staticRenderFns } from "./TabsManager.vue?vue&type=template&id=7ff0a6de&scoped=true&"
import script from "./TabsManager.vue?vue&type=script&lang=js&"
export * from "./TabsManager.vue?vue&type=script&lang=js&"
import style0 from "./TabsManager.vue?vue&type=style&index=0&id=7ff0a6de&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0a6de",
  null
  
)

export default component.exports